import { useState } from "react";
import { MessageSquareText } from "lucide-react";
import useAuth from "../../../core/hooks/useAuth";
import FeedbackPanel from "./FeedbackPanel";

const FeedbackWidget = () => {
  const { isLoggedIn } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Only render for authenticated users
  if (!isLoggedIn) return null;

  return (
    <>
      {/* ── Floating Trigger Button ── */}
      <button
        onClick={() => setIsOpen(true)}
        className={`fixed bottom-24 right-6 z-50
          flex items-center gap-2 px-4 py-2.5
          bg-primary-500 hover:bg-primary-600 active:bg-primary-700
          text-white text-sm font-semibold
          rounded-full shadow-lg hover:shadow-xl
          transition-all duration-300 ease-out
          hover:scale-105 active:scale-95
          ${isOpen ? "opacity-0 pointer-events-none scale-90" : "opacity-100"}`}
        aria-label="Open feedback form"
      >
        <MessageSquareText size={18} />
        <span className="hidden sm:inline">Feedback</span>
      </button>

      {/* ── Feedback Panel ── */}
      <FeedbackPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default FeedbackWidget;
